export default __webpack_public_path__ + "3f7acd913c7761fea7b9ebd2e162515a.glb";